<template>
	<div class="wrap">
		<div class="pageHeader">
			<div class="logoBox">
				<el-image class="logo" style="margin-right: 19px;" src="https://test.dzyxedu.com/homeImage/LOGO%E5%A2%99-02.png%403x.png" fit="fill" @click="goIndex"></el-image>
				<el-image class="logo" src="https://test.dzyxedu.com/homeImage/LOGO%E5%A2%99-03.png%403x.png" fit="fill" @click="goIndex"></el-image>
			</div>

			<div style="width: fit-content; display: flex; align-items: center; justify-content: space-between;">
				<div class="funs">
					<div class="funcImageBox" @click="jumpOpenUrl('https://dzyxjy.tmall.com/index.htm')">
						<el-image src="https://test.dzyxedu.com/homeImage/%E5%A4%A9%E7%8C%AB.png" fit="fill"></el-image>
					</div>
					<div class="funcImageBox">
						<el-popover placement="bottom" width="115" trigger="hover">
							<div style="text-align: center;">
								<el-image src="https://test.dzyxedu.com/homeImage/%E6%8A%96%E9%9F%B3%E5%8F%B7%E4%BA%8C%E7%BB%B4%E7%A0%81.png" fit="fill"></el-image>
								<div>抖音APP扫码查看</div>
							</div>
							<el-image slot="reference" src="https://test.dzyxedu.com/homeImage/%E6%8A%96%E9%9F%B3.png" fit="fill"></el-image>
						</el-popover>
					</div>
					<div class="funcImageBox" style="width: 60px;">
						<el-popover placement="bottom" width="115" trigger="hover">
							<div style="text-align: center;">
								<el-image src="https://test.dzyxedu.com/homeImage/app%E4%B8%8B%E8%BD%BD%E4%BA%8C%E7%BB%B4%E7%A0%81.png" fit="fill"></el-image>
								<div>扫码下载APP</div>
							</div>
							<div slot="reference">
								<el-image style="width: 30px; height: 30px; margin: 0 auto;" src="https://test.dzyxedu.com/homeImage/%E6%89%8B%E6%9C%BA.png" fit="fill"></el-image>
								<div style="font-size: 12px; color: #FF9E74;">
									APP下载
								</div>
							</div>
						</el-popover>
					</div>
				</div>
				<div class="loginBox">
					<el-button v-if="!isLogin" size="small" @click="clickLogin">登录</el-button>
					<el-button v-if="isLogin" size="small" @click="goCenter">学习中心</el-button>
					<el-button v-if="isLogin" size="small" class="message-center-header-btn" @click="openMessageCenter">
						<i class="el-icon-message"></i>
						<span>消息中心</span>
						<el-badge v-if="unreadCount > 0" :value="unreadCount" class="message-badge"></el-badge>
					</el-button>
					<el-button v-if="isLogin" size="small" @click="clickLogin">退出</el-button>
				</div>
			</div>
		</div>
		<div class="pageNavbar" v-show="!isLogin">
			<div style="width: 1085px; margin: 0 auto;">
				<el-menu
					style="display: flex; justify-content: space-between; border: 0;"
					background-color="#F5F6F8"
					text-color="#8A8A8A"
					active-text-color="#424242"
					default-active="1"
					class="el-menu-demo"
					mode="horizontal"
					@select="handleSelect"
				>
					<template v-for="(item, index) in navbarList" :index="index">
						<el-menu-item :index="item.key" v-if="!item.children">
							<div class="menuTitle">
								{{ item.name }}
								<div v-show="activeKey === item.key" class="navbarLine"></div>
							</div>
						</el-menu-item>
						<el-submenu :index="item.key" v-else>
							<template slot="title">
								<div class="menuTitle">
									{{ item.name }}
									<div v-show="activeKey === item.key" class="navbarLine"></div>
								</div>
							</template>
							<el-menu-item :index="subItem.key" v-for="(subItem, subIndex) in item.children" :key="subIndex">
								<span class="subMenuTitle">{{ subItem.name }}</span>
							</el-menu-item>
						</el-submenu>
					</template>
				</el-menu>
			</div>
		</div>

		<el-dialog :visible.sync="openLogin" width="440px" lock-scroll :modal-append-to-body="false" :close-on-click-modal="false">
			<div slot="title" class="login-header">
				<div>{{ loginType === 0 ? '欢迎登录丁震医学教育' : '欢迎注册丁震医学教育' }}</div>
				<div class="login-sub-header">WELCOME</div>
			</div>
			<el-form ref="loginForm" :model="loginForm" :rules="loginRules">
				<el-form-item prop="phone">
					<!-- <el-input class="login-input" v-model="loginForm.phone" placeholder="请输入手机号" @keyup.enter.native="handleLogin" prefix-icon="el-icon-user" /> -->
					<el-input class="login-input" :disabled="loginType === 1 && isSend" autocomplete="off" v-model="loginForm.phone" placeholder="请输入手机号" prefix-icon="el-icon-user" />
				</el-form-item>
				<el-form-item v-if="loginType === 1">
					<div style="display: flex; align-items: center; justify-content: space-between; margin: 0 20px;">
						<div class="form-row">
							<el-input class="login-input" style="width: 200px;" type="text" autocomplete="off" v-model="loginForm.imgVCode" placeholder="请输入计算结果" prefix-icon="el-icon-printer" />
						</div>
						<div class="login-code" style="width: 112px; height: 41px; cursor: pointer;">
							<img style="width: 100%; height: 100%;" :src="imageUrl" @click="getImgCode" class="login-code-img" />
						</div>
					</div>
				</el-form-item>
				<el-form-item v-if="loginType === 1">
					<div style="display: flex; align-items: center; justify-content: space-between; margin: 0 20px;">
						<div class="form-row">
							<el-input class="login-input" style="width: 200px;" type="text" autocomplete="off" v-model="loginForm.code" placeholder="请输入短信验证码" prefix-icon="el-icon-message" />
						</div>
						<el-button style="height: 41px;" @click="getCode">
							{{ smsCode }}
						</el-button>
					</div>
				</el-form-item>
				<el-form-item prop="password">
					<!-- <el-input class="login-input" v-model="loginForm.password" type="password" placeholder="请输入密码" @keyup.enter.native="handleLogin" show-password prefix-icon="el-icon-lock" /> -->
					<el-input class="login-input" v-model="loginForm.password" type="password" placeholder="请输入密码" show-password prefix-icon="el-icon-lock" />
				</el-form-item>
			</el-form>
			<div style="margin-top: 45px;" class="login-btn">
				<el-button @click="handleLogin" v-if="loginType === 0">登 录</el-button>
				<el-button @click="register" v-if="loginType === 1">注 册</el-button>
			</div>
			<div style="width: 360px; margin: 0 auto; display: flex; align-items: center; justify-content: space-between;">
				<el-checkbox v-model="isRemember" v-if="loginType === 0">记住我</el-checkbox>
				<el-button
					type="text"
					v-if="loginType === 0"
					@click="
						loginType = 1;
						getImgCode();
					"
					>去注册</el-button
				>
				<el-button type="text" v-if="loginType === 1" @click="loginType = 0">去登录</el-button>
			</div>
		</el-dialog>

		<!-- 消息列表弹窗 -->
		<el-dialog
			title="消息中心"
			:visible.sync="messageListVisible"
			width="600px"
			:close-on-click-modal="false"
			:modal-append-to-body="true"
			:append-to-body="true"
			@opened="loadMessageList"
		>
			<div class="message-list-container">
				<div v-if="messageList.length === 0" class="empty-message">暂无消息</div>
				<div v-else>
					<div
						v-for="message in messageList"
						:key="message.messageId"
						class="message-item"
						:class="{ 'unread': message.isRead === 0 || message.isRead === '0' }"
					>
						<div class="message-icon-wrapper">
							<div class="message-icon-bg" :class="getMessageTypeClass(message.messageType)">
								<el-image :src="getMessageIconUrl(message.messageType)" fit="contain" class="message-icon"></el-image>
							</div>
						</div>
						<div class="message-content" @click="viewMessageDetail(message)">
							<div class="message-title">{{ message.messageTitle }}</div>
							<div class="message-meta">
								<span class="message-type-tag" :class="getMessageTypeClass(message.messageType)">
									{{ getMessageTypeName(message.messageType) }}
								</span>
								<span class="message-time">{{ message.createTime }}</span>
							</div>
						</div>
						<el-button
							type="text"
							icon="el-icon-delete"
							class="delete-btn"
							@click.stop="deleteMessage(message.messageId)"
						></el-button>
					</div>
					<div class="pagination-container">
						<el-pagination
							@size-change="handleSizeChange"
							@current-change="handleCurrentChange"
							:current-page="pagination.pageNum"
							:page-sizes="[10, 20, 50]"
							:page-size="pagination.pageSize"
							layout="total, sizes, prev, pager, next, jumper"
							:total="pagination.total"
						></el-pagination>
					</div>
				</div>
			</div>
		</el-dialog>

		<!-- 消息详情弹窗 -->
		<el-dialog
			title="消息详情"
			:visible.sync="messageDetailVisible"
			width="50%"
			style="margin-top: -5vh;"
			:close-on-click-modal="false"
			:modal-append-to-body="true"
			:append-to-body="true"
			class="message-detail-dialog"
		>
			<div v-if="messageDetail" class="message-detail-container">
				<!-- 标题和时间区域 -->
				<div class="detail-header">
					<div class="detail-header-top">
						<div class="detail-icon-wrapper">
							<div class="detail-icon-bg" :class="getMessageTypeClass(messageDetail.messageType)">
								<el-image :src="getMessageIconUrl(messageDetail.messageType)" fit="contain" class="detail-icon"></el-image>
							</div>
						</div>
						<span class="detail-time">{{ messageDetail.createTime }}</span>
					</div>
					<div class="detail-title">{{ messageDetail.messageTitle }}</div>
				</div>
				<!-- 消息内容 -->
				<div class="detail-content-wrapper">
					<div class="detail-content" v-html="messageDetail.messageContent"></div>
				</div>
				<!-- 二维码区域 -->
				<div v-if="messageDetail.wechaQrCode" class="detail-qrcode-wrapper">
					<el-image :src="messageDetail.wechaQrCode" fit="contain" class="detail-qrcode"></el-image>
				</div>
			</div>
		</el-dialog>

		<!-- 未读消息提醒弹窗 -->
		<el-dialog
			:visible="unreadMessageDialogVisible"
			width="400px"
			:close-on-click-modal="false"
			:close-on-press-escape="false"
			:show-close="false"
			:modal-append-to-body="true"
			:append-to-body="true"
			class="unread-message-dialog"
			:before-close="handleBeforeClose"
		>
			<div class="unread-message-content">
				<div class="unread-message-icon">
					<i class="el-icon-bell" style="font-size: 60px; color: #ff9e74;"></i>
				</div>
				<div class="unread-message-title">新消息提醒</div>
				<div class="unread-message-text">
					您有<span class="unread-count">{{ unreadMessageTotal }}</span>条新消息，请及时查看!
				</div>
				<el-button type="primary" class="unread-message-btn" @click="goToMessageList">去查看</el-button>
			</div>
		</el-dialog>

    <el-dialog
      title="验证"
      :visible.sync="validate_device"
      width="440px"
      lock-scroll
      :modal-append-to-body="false"
      :close-on-click-modal="false"
    >
      <div slot="title" class="login-header">
        <div>设备验证</div>
        <div class="login-sub-header">VERIFICATION</div>
      </div>
      <div style="margin: 0 40px 20px;">
        <div style="margin-bottom: 20px; font-size: 16px;">
          <span>手机号：</span>
          <span style="font-weight: 500; color: #333;">{{ loginForm.phone }}</span>
        </div>
        <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 30px;">
          <div class="form-row">
            <el-input class="login-input" style="width: 200px;" type="text" autocomplete="off" v-model="loginForm.code" placeholder="请输入短信验证码" prefix-icon="el-icon-message" />
          </div>
          <el-button style="height: 41px;" @click="getVCode">
            {{ smsCode }}
          </el-button>
        </div>
        <div style="text-align: center;">
          <el-button @click="validateLogin" style="width: 360px; height: 50px; border-radius: 25px; background: #ff9e74; color: white; border: 1px solid #ff9e74;">
            登 录
          </el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      title="完善用户信息"
      :visible.sync="validate_name"
      width="440px"
      lock-scroll
      :modal-append-to-body="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <div style="margin: 0 40px;">
        <div style="margin-bottom: 30px;">
          <el-input class="login-input" style="width: 100%;" type="text" autocomplete="off" v-model="validate_real_name" placeholder="请输入真实姓名" prefix-icon="el-icon-user-solid" />
        </div>
        <div style="text-align: center;">
          <el-button @click="updateRealName" style="width: 100%; height: 50px; border-radius: 25px; background: #ff9e74; color: white; border: 1px solid #ff9e74;">
            确 认
          </el-button>
        </div>
      </div>
    </el-dialog>
	</div>
</template>

<script>
	import {
		apiLogin,
		apiGetCaptchaImage,
		apiGetRegisterCode,
		apiRegister,
		apiGetMessageList,
		apiGetMessageDetail,
		apiMarkMessageRead,
		apiDeleteMessage,
		apiGetUnreadCount,
    apiForgetPhoneCode,
    apiUpdateUserInfo
	} from '@/api/api';
	import Cookies from 'js-cookie';
	import { apiSetOnline } from '../api/api';
	const TokenKey = 'Admin-Token';

	export default {
		name: 'CustomHeader',
		data() {
			return {
				activeIndex: '1',
				navbarList: [
					{ key: '1', name: '首页', url: '/' },
					{ key: '2', name: '品牌故事', url: '/brandStory' },
					{
						key: '3',
						name: '备考图书',
						url: 'index',
						children: [
							{
								key: '3-1',
								name: '护理学（中级）',
								url: 'https://dzyxjy.tmall.com/category-1506545860.htm',
							},
							{ key: '3-2', name: '护理学（师）', url: 'https://dzyxjy.tmall.com/category-1506545859.htm' },
							{ key: '3-3', name: '护士执业资格', url: 'https://dzyxjy.tmall.com/category-1506545858.htm' },
							{ key: '3-4', name: '职称类图书', url: 'https://dzyxjy.tmall.com/category-1509776950.htm' },
						],
					},
					{
						key: '4',
						name: '选课中心',
						url: 'index',
						children: [
							{
								key: '4-1',
								name: '主管护师课程',
								url: 'https://dzyxjy.tmall.com/category-1608766121.htm',
							},
							{
								key: '4-2',
								name: '护师培训课程',
								url: 'https://dzyxjy.tmall.com/category-1608766120.htm',
							},
							{
								key: '4-3',
								name: '护士培训课程',
								url: 'https://dzyxjy.tmall.com/category-1608766119.htm',
							},
						],
					},
					{ key: '5', name: '考情资讯', url: '/information' },
					{ key: '6', name: '联系我们', url: '/contact' },
				],
				activeKey: '1',
				openLogin: false,
				loginForm: {
					phone: '',
					password: '',
					code: '',
				},
				loginRules: {
					phone: [{ required: true, message: '请输入手机号', trigger: 'blur' }],
					password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
				},
				isLogin: !!Cookies.get(TokenKey),
				isRemember: false,

				loginType: 0,

				imageUrl: '',
				codeTime: 60,
				timer: null,
				smsCode: '获取验证码',
				allowSend: true,

				isSend: false,

				// 消息中心相关
				messageListVisible: false,
				messageDetailVisible: false,
				messageList: [],
				messageDetail: null,
				currentMessageId: null,
				unreadCount: 0,
				pagination: {
					pageNum: 1,
					pageSize: 10,
					total: 0,
				},
				// 未读消息提醒弹窗
				unreadMessageDialogVisible: false,
				unreadMessageTotal: 0,

        validate_device: false,

        validate_name: false,
        validate_real_name: ''
			};
		},
		watch: {
			codeTime(value) {
				if (value !== 60 && value !== 0) {
					this.smsCode = `重新发送（${value}）`;
					console.log('----------', this.smsCode);
				} else {
					this.smsCode = '获取验证码';
				}
			},
			loginType(value) {
				this.loginForm = {
					phone: '',
					password: '',
				};
			},
		},
		mounted() {
			// 如果用户已登录，检查未读消息
			if (this.isLogin) {
				this.checkUnreadMessages();
        const { isVirtualCount, studentInfo } = JSON.parse(Cookies.get(TokenKey));
        if (isVirtualCount && !studentInfo.real_name) {
          this.validate_name = true
        }
			}
		},
		methods: {
			handleSelect(index, indexPath) {
				if (indexPath.length === 1) {
					this.activeKey = indexPath[0];
					const menu = this.navbarList.find(item => item.key === this.activeKey);
					this.$router.push(menu.url);
				} else {
					const menuF = this.navbarList.find(item => item.key === indexPath[0]);
					const menuChild = menuF.children.find(item => item.key === indexPath[1]);
					this.jumpOpenUrl(menuChild.url);
				}
				// this.$router.push()
			},
			handleSelectByPath(path) {
				const menu = this.navbarList.find(item => item.url === path);
				this.handleSelect(_, [menu.key]);
			},
			jumpOpenUrl(url) {
				window.open(url);
			},
			goCenter() {
				this.$router.push('/home/myVideo');
			},
			goIndex() {
				this.$router.replace('/');
			},
			clickLogin() {
				if (this.isLogin) {
					this.$confirm('确定退出登录, 是否继续?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning',
					}).then(() => {
						Cookies.remove(TokenKey);
						this.$router.replace('/');
						this.isLogin = false;
					});
				} else {
					const ua = window.navigator.userAgent;
					const msie = ua.indexOf('MSIE ');
					const trident = ua.indexOf('Trident/');

					if (msie > 0 || trident > 0) {
						this.$alert('您正在使用不支持的浏览器版本。请升级到Chrome、Firefox、Edge等现代浏览器以获得最佳体验。', '提示', {
							confirmButtonText: '确定',
							callback: action => {},
						});
					} else {
						this.openLogin = true;
						const rememberUser = Cookies.get('dz-user');
						if (rememberUser) {
							this.loginForm = JSON.parse(Cookies.get('dz-user'));
							this.isRemember = true;
						}
					}
				}
			},
			handleLogin() {
				this.$refs.loginForm.validate(valid => {
					if (valid) {
						apiLogin({
							...this.loginForm,
							device_type: '2',
						}).then(res => {
							if (res.code === 200) {
								if (this.isRemember) {
									Cookies.set('dz-user', JSON.stringify(this.loginForm));
								}
								this.isLogin = true;
								Cookies.set(TokenKey, JSON.stringify(res.data));
								this.$router.push('/home/myVideo');
								this.openLogin = false;
								apiSetOnline({ online_key: `50#${res.data.studentInfo.studentId}` });
								setInterval(() => {
									apiSetOnline({ online_key: `50#${res.data.studentInfo.studentId}` });
								}, 300 * 1000);
								// 登录成功后获取未读消息数
								this.checkUnreadMessages();
                if (res.data.isVirtualCount && !res.data.studentInfo.real_name) {
                  this.validate_name = true
                }
							} else {
                this.validate_device = true
								// this.$message.error(res.msg);
							}
						});
					}
				});
			},
			getImgCode() {
				apiGetCaptchaImage().then(res => {
					const { img, uuid } = res;
					this.loginForm.imageUuid = uuid;
					this.imageUrl = 'data:image/gif;base64,' + img;
				});
			},

			getCode() {
				if (!this.allowSend) {
					return;
				}
				if (!this.loginForm.phone) {
					this.$message.warning('请输入手机号');
					return;
				}
				apiGetRegisterCode(this.loginForm.phone, this.loginForm.imageUuid, this.loginForm.imgVCode).then(res => {
					if (res.code === 200) {
						this.loginForm.uuid = res.data.codeId;
						this.allowSend = false;
						this.isSend = true;
						this.timer = setInterval(() => {
							this.codeTime -= 1;
							if (this.codeTime <= 0) {
								this.allowSend = true;
								this.codeTime = 60;
								clearInterval(this.timer);
								this.timer = null;
							}
						}, 1000);
					} else {
						this.message.error(res.msg);
					}
				});
			},

			register() {
				this.$confirm('手机号一旦被注册将无法被修改，请您使用长期使用的手机号注册，谢谢！', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
				})
					.then(() => {
						apiRegister({
							phone: this.loginForm.phone,
							password: this.loginForm.password,
							code: this.loginForm.code,
							uuid: this.loginForm.uuid,
						}).then(res => {
							if (res.code === 200) {
								this.$message.success('注册成功');
								this.loginType = 0;
							} else {
								this.$message.error(res.msg);
							}
						});
					})
					.catch(() => {});
			},
			// 打开消息中心
			openMessageCenter() {
				this.messageListVisible = true;
			},
			// 加载消息列表
			loadMessageList() {
				apiGetMessageList({
					pageNum: this.pagination.pageNum,
					pageSize: this.pagination.pageSize,
				})
					.then(res => {
						if (res.code === 200) {
							// 根据实际返回结构处理数据
							this.messageList = res.rows || [];
							this.pagination.total = res.total || 0;
							// 计算未读数量（isRead 可能是字符串 "0" 或数字 0）
							this.unreadCount = this.messageList.filter(msg => msg.isRead === 0 || msg.isRead === "0").length;
							// 检查未读消息总数，如果为0则关闭弹窗
							this.checkAndUpdateUnreadDialog();
						} else {
							this.$message.error(res.msg || '获取消息列表失败');
						}
					})
					.catch(err => {
						this.$message.error('获取消息列表失败');
					});
			},
			// 查看消息详情
			viewMessageDetail(message) {
				this.currentMessageId = message.messageId;
				// 获取消息详情
				apiGetMessageDetail(message.messageId)
					.then(res => {
						if (res.code === 200) {
							this.messageDetail = res.data;
							// 确保 messageType 存在（如果详情接口没有返回，使用列表中的）
							if (!this.messageDetail.messageType && message.messageType) {
								this.messageDetail.messageType = message.messageType;
							}
							this.messageDetailVisible = true;
							// 如果消息未读，标记为已读（兼容字符串和数字）
							if (message.isRead === 0 || message.isRead === "0") {
								apiMarkMessageRead(message.messageId)
									.then(readRes => {
										if (readRes.code === 200) {
											message.isRead = 1;
											// 更新未读数量
											this.unreadCount = Math.max(0, this.unreadCount - 1);
											// 检查未读消息总数，如果为0则关闭弹窗
											this.checkAndUpdateUnreadDialog();
										}
									})
									.catch(() => {});
							}
						} else {
							this.$message.error(res.msg || '获取消息详情失败');
						}
					})
					.catch(err => {
						this.$message.error('获取消息详情失败');
					});
			},
			// 删除消息
			deleteMessage(messageId) {
				this.$confirm('确定要删除这条消息吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
				})
					.then(() => {
						apiDeleteMessage(messageId)
							.then(res => {
								if (res && res.code === 200) {
									this.$message.success('删除成功');
									// 重新加载消息列表
									this.loadMessageList();
								} else if (res && res.code) {
									// 业务错误
									this.$message.error(res.msg || '删除失败');
								} else {
									// HTTP 错误（如 404），显示错误信息
									this.$message.error('删除失败，请稍后重试');
								}
							})
							.catch(err => {
								// 捕获错误并显示提示
								if (err && err.response) {
									if (err.response.status === 404) {
										this.$message.error('删除接口不存在或消息已被删除');
									} else {
										this.$message.error(err.message || '删除失败，请稍后重试');
									}
								} else {
									this.$message.error('删除失败，请稍后重试');
								}
							});
					})
					.catch(() => {});
			},
			// 分页大小改变
			handleSizeChange(val) {
				this.pagination.pageSize = val;
				this.pagination.pageNum = 1;
				this.loadMessageList();
			},
			// 当前页改变
			handleCurrentChange(val) {
				this.pagination.pageNum = val;
				this.loadMessageList();
			},
			// 检查未读消息数
			checkUnreadMessages() {
				apiGetUnreadCount()
					.then(res => {
						if (res.code === 200 && res.data) {
							this.unreadMessageTotal = res.data.total || 0;
							// 如果有未读消息，显示弹窗；如果没有，关闭弹窗
							if (this.unreadMessageTotal > 0) {
								this.unreadMessageDialogVisible = true;
							} else {
								this.unreadMessageDialogVisible = false;
							}
						}
					})
					.catch(err => {
						// 静默失败，不影响登录流程
					});
			},
			// 检查并更新未读消息弹窗状态
			checkAndUpdateUnreadDialog() {
				apiGetUnreadCount()
					.then(res => {
						if (res.code === 200 && res.data) {
							this.unreadMessageTotal = res.data.total || 0;
							// 如果没有未读消息，关闭弹窗
							if (this.unreadMessageTotal === 0) {
								this.unreadMessageDialogVisible = false;
							} else {
								// 如果有未读消息，确保弹窗显示并更新数量
								this.unreadMessageDialogVisible = true;
							}
						}
					})
					.catch(err => {
						// 静默失败
					});
			},
			// 阻止弹窗关闭
			handleBeforeClose(done) {
				// 检查未读消息数，如果没有未读消息才允许关闭
				apiGetUnreadCount()
					.then(res => {
						if (res.code === 200 && res.data && res.data.total === 0) {
							done();
						}
						// 如果有未读消息，不允许关闭
					})
					.catch(() => {
						// 出错时不允许关闭
					});
			},
			// 去查看消息
			goToMessageList() {
				// 不关闭弹窗，只打开消息列表
				this.openMessageCenter();
			},
			// 获取消息类型名称
			getMessageTypeName(messageType) {
				const typeMap = {
					'1': '系统消息',
					'2': '教务消息',
					'3': '教研消息',
				};
				return typeMap[messageType] || '未知类型';
			},
			// 获取消息类型样式类
			getMessageTypeClass(messageType) {
				const classMap = {
					'1': 'type-system',
					'2': 'type-academic',
					'3': 'type-research',
				};
				return classMap[messageType] || '';
			},
			// 获取消息图标URL
			getMessageIconUrl(messageType) {
				// 转换为字符串以确保兼容性
				const type = String(messageType);
				const iconMap = {
					'1': 'https://test.dzyxedu.com/qrcode/1768450912420name=icon-系统消息@2x.png',
					'2': 'https://test.dzyxedu.com/qrcode/1768450775041name=icon-教务消息@2x.png',
					'3': 'https://test.dzyxedu.com/qrcode/1768450892778name=icon-教研消息@2x.png',
				};
				return iconMap[type] || iconMap['1'];
			},

      getVCode() {
        if (!this.allowSend) {
          return;
        }
        if (!this.loginForm.phone) {
          this.$message.warning('请输入手机号');
          return;
        }
        const phoneRegular = /^1\d{10}$/;
        if (!phoneRegular.test(this.loginForm.phone)) {
          this.$message.warning('手机号格式不正确');
          return;
        }
        apiForgetPhoneCode(this.loginForm.phone).then(res => {
          if (res.code === 200) {
            this.allowSend = false;
            this.timer = setInterval(() => {
              this.codeTime -= 1;
              if (this.codeTime <= 0) {
                this.allowSend = true;
                this.codeTime = 60;
                clearInterval(this.timer);
                this.timer = null;
              }
            }, 1000);
            this.$message.success('验证码已发送');
          } else {
            this.$message.error(res.msg);
          }
        });
      },

      validateLogin() {
        if (!this.loginForm.code) {
          this.$message.warning('请输入短信验证码');
          return;
        }
        apiLogin({
          ...this.loginForm,
          device_type: '2',
        }).then(res => {
          if (res.code === 200) {
            if (this.isRemember) {
              Cookies.set('dz-user', JSON.stringify(this.loginForm));
            }
            this.isLogin = true;
            Cookies.set(TokenKey, JSON.stringify(res.data));
            this.$router.push('/home/myVideo');
            this.validate_device = false;
            this.openLogin = false;
            apiSetOnline({ online_key: `50#${res.data.studentInfo.studentId}` });
            setInterval(() => {
              apiSetOnline({ online_key: `50#${res.data.studentInfo.studentId}` });
            }, 300 * 1000);
            // 登录成功后获取未读消息数
            this.checkUnreadMessages();
          } else {
            this.$message.error(res.msg);
          }
        });
      },

      updateRealName() {
        apiUpdateUserInfo({
          real_name: this.validate_real_name,
        }).then(res => {
          if (res.code === 200) {
            this.validate_name = false
            this.validate_real_name = ''
            const tokenData = JSON.parse(Cookies.get(TokenKey))
            Cookies.set(TokenKey, JSON.stringify({
              ...tokenData,
              studentInfo: res.data,
              isVirtualCount: true
            }));
          }
        })
      }
		},
	};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.pageHeader {
		min-width: 1903px;
		height: 60px;
		background: rgba(255, 255, 255, 1);
		border-bottom: 1px solid rgba(232, 234, 237, 1);
		padding: 4px 80px;
		display: flex;
		align-items: center;
		box-sizing: border-box;
		justify-content: space-between;
	}

	.logoBox {
		width: 420px;
		height: 60px;
		display: flex;
		align-items: center;
	}

	.logo {
		height: 100%;
		cursor: pointer;
	}

	.loginBox {
		display: flex;
		padding: 0 10px;
		cursor: pointer;
		max-width: 200px;
	}

	.loginBox button {
		background-color: #ff9e74;
		color: white;
		border: 1px solid #ff9e74;
	}

	.funs {
		width: 200px;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.funcImageBox {
		width: 40px;
		height: 40px;
		text-align: center;
	}

	.pageNavbar {
		background-color: #f5f6f8;
		box-sizing: border-box;
		border-bottom: 1px solid #e6e6e6;
	}

	.menuTitle {
		font-size: 18px;
		position: relative;
		display: inline-block;
	}

	.subMenuTitle {
		font-size: 16px;
	}

	.navbarLine {
		width: 60px;
		height: 4px;
		background-color: #f55e30;
		position: absolute;
		left: 50%;
		bottom: 5px;
		transform: translateX(-50%);
	}

	.login-header {
		width: 100%;
		height: 53px;
		font-size: 32px;
		font-weight: 700;
		letter-spacing: 0px;
		line-height: 52.13px;
		color: rgba(0, 0, 0, 1);
		text-align: center;
		padding-top: 44px;
		margin-bottom: 26px;
	}

	.login-sub-header {
		height: 29px;
		opacity: 1;
		/** 文本1 */
		font-size: 20px;
		font-weight: 400;
		letter-spacing: 2px;
		line-height: 28.96px;
		color: rgba(0, 0, 0, 0.6);
		text-align: center;
	}

	.login-input {
		width: 360px;
		height: 40px;
		opacity: 1;
		left: 50%;
		transform: translateX(-50%);
		font-size: 18px;
	}

	.login-btn {
		text-align: center;
		margin-bottom: 45px;
	}

	.login-btn button {
		width: 360px;
		height: 50px;
		opacity: 1;
		border-radius: 25px;
		background: #ff9e74;
		color: white;
		border: 1px solid #ff9e74;
	}

	/deep/ .el-menu--horizontal > .el-menu-item.is-active {
		border-bottom: 0 !important;
	}

	/deep/ .el-menu--horizontal > .el-menu-item {
		border-bottom: 0 !important;
	}

	/deep/ .el-menu--horizontal > .el-submenu.is-active .el-submenu__title {
		border-bottom: 0 !important;
	}

	/deep/ .el-menu--horizontal > .el-submenu .el-submenu__title {
		border-bottom: 0 !important;
	}

	/deep/ .el-menu--horizontal > .el-menu-item:hover {
		background-color: white !important;
		color: #424242 !important;
	}

	/deep/ .el-menu--horizontal > .el-submenu .el-submenu__title:hover {
		background-color: white !important;
		color: #424242 !important;
	}

	/deep/ .el-menu--horizontal .el-menu-item:not(.is-disabled):focus,
	.el-menu--horizontal .el-menu-item:not(.is-disabled):hover {
		background-color: white !important;
		color: #424242 !important;
	}

	/* 消息中心样式 */
	.message-center-header-btn {
		position: relative;
	}

	.message-center-header-btn i {
		margin-right: 4px;
	}

	.message-badge {
		position: absolute;
		top: -8px;
		right: -8px;
	}

	.message-list-container {
		min-height: 300px;
		max-height: 500px;
		overflow-y: auto;
	}

	.empty-message {
		text-align: center;
		padding: 60px 0;
		color: #999;
		font-size: 16px;
	}

	.message-item {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 15px;
		margin-bottom: 10px;
		background-color: #fff;
		border: 1px solid #e6e6e6;
		border-radius: 8px;
		box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
		transition: all 0.3s;
	}

	.message-item:hover {
		box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
	}

	.message-item.unread {
		background-color: #fff5f0;
		border-color: #ff9e74;
	}

	.message-icon-wrapper {
		margin-right: 15px;
		flex-shrink: 0;
	}

	.message-icon-bg {
		width: 50px;
		height: 50px;
		border-radius: 50%;
		display: flex;
		align-items: center;
		justify-content: center;
		overflow: hidden;
	}

	/* .message-icon-bg.type-system {
		background-color: #ffd93d;
	}

	.message-icon-bg.type-academic {
		background-color: #ffd93d;
	}

	.message-icon-bg.type-research {
		background-color: #ffd93d;
	} */

	.message-icon {
		width: 30px;
		height: 30px;
	}

	.message-content {
		flex: 1;
		cursor: pointer;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		min-width: 0;
	}

	.message-title {
		font-size: 16px;
		color: #424242;
		margin-bottom: 8px;
		line-height: 1.4;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.message-item.unread .message-title {
		font-weight: 600;
		color: #333;
	}

	.message-meta {
		display: flex;
		align-items: center;
		gap: 10px;
	}

	.message-type-tag {
		display: inline-block;
		padding: 2px 8px;
		border: 1px solid #d9d9d9;
		border-radius: 4px;
		font-size: 12px;
		color: #666;
		background-color: #f5f5f5;
		white-space: nowrap;
	}

	.message-time {
		font-size: 12px;
		color: #999;
		white-space: nowrap;
	}

	.delete-btn {
		margin-left: 15px;
		color: #999;
		font-size: 18px;
	}

	.delete-btn:hover {
		color: #f56c6c;
	}

	.pagination-container {
		margin-top: 20px;
		text-align: right;
	}

	/* 消息详情弹窗固定高度 */
	.message-detail-dialog /deep/ .el-dialog__body {
		max-height: 70vh;
		overflow: hidden;
		padding: 20px;
		display: flex;
		flex-direction: column;
	}

	.message-detail-container {
		padding: 10px 0;
		height: 100%;
		overflow-y: auto;
		overflow-x: hidden;
	}

	.detail-header {
		margin-bottom: 20px;
		padding-bottom: 15px;
		border-bottom: 1px solid #e6e6e6;
	}

	.detail-header-top {
		display: flex;
		align-items: center;
		margin-bottom: 12px;
	}

	.detail-icon-wrapper {
		margin-right: 12px;
	}

	.detail-icon-bg {
		width: 44px;
		height: 44px;
		border-radius: 50%;
		display: flex;
		align-items: center;
		justify-content: center;
		overflow: hidden;
	}

	.detail-icon {
		width: 28px;
		height: 28px;
	}

	.detail-time {
		font-size: 12px;
		color: #999;
	}

	.detail-title {
		font-size: 18px;
		font-weight: 600;
		color: #333;
		line-height: 1.5;
	}

	.detail-content-wrapper {
		margin-top: 0px;
	}

	.detail-content {
		color: #333;
		line-height: 1.6;
		word-wrap: break-word;
	}

	.detail-qrcode-wrapper {
		margin-top: 20px;
		text-align: center;
		padding: 20px;
		background-color: #f9f9f9;
		border-radius: 8px;
	}

	.detail-qrcode {
		max-width: 100%;
		height: auto;
	}

	/* 未读消息提醒弹窗样式 */
	.unread-message-dialog /deep/ .el-dialog {
		border-radius: 12px;
		overflow: hidden;
	}

	.unread-message-dialog /deep/ .el-dialog__header {
		display: none;
	}

	.unread-message-dialog /deep/ .el-dialog__body {
		padding: 0;
	}

	.unread-message-content {
		text-align: center;
		padding: 40px 30px 30px;
		background: linear-gradient(180deg, #fff 0%, #f9f9f9 100%);
	}

	.unread-message-icon {
		margin-bottom: 20px;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.unread-message-title {
		font-size: 24px;
		font-weight: 600;
		color: #333;
		margin-bottom: 15px;
	}

	.unread-message-text {
		font-size: 16px;
		color: #666;
		margin-bottom: 30px;
		line-height: 1.5;
	}

	.unread-count {
		color: #f56c6c;
		font-weight: 600;
		font-size: 18px;
		margin: 0 2px;
	}

	.unread-message-btn {
		width: 100%;
		height: 45px;
		background-color: #f56c6c;
		border-color: #f56c6c;
		font-size: 16px;
		border-radius: 6px;
	}

	.unread-message-btn:hover {
		background-color: #f78989;
		border-color: #f78989;
	}
</style>



// WEBPACK FOOTER //
// src/components/CustomHeader.vue